import { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const { setUser, csrfToken } = useAuth();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      const { data } = await axios.post('/auth/login', form, {
        headers: { 'X-CSRF-Token': csrfToken }
      });
      setUser(data.user);
      navigate(data.user.role === 'admin' ? '/admin' : '/dashboard', { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setBusy(false);
    }
  }

  function googleLogin() {
    window.location.href = process.env.REACT_APP_API_URL + '/auth/google';
  }

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-12 col-md-6 col-lg-5">
          <div className="card shadow-sm">
            <div className="card-body p-4">
              <h1 className="h4 mb-3 text-center">Login</h1>
              {error && <div className="alert alert-danger">{error}</div>}

              <button className="btn btn-outline-dark w-100 mb-3" onClick={googleLogin}>
                <img alt="Google" src="https://www.gstatic.com/images/branding/product/1x/googleg_24dp.png" className="me-2" />
                Login with Google
              </button>

              <div className="text-center text-muted my-2">or</div>

              <form onSubmit={onSubmit} noValidate>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input type="email" className="form-control" required
                    value={form.email}
                    onChange={e => setForm({ ...form, email: e.target.value })} />
                </div>
                <div className="mb-3">
                  <label className="form-label">Password</label>
                  <input type="password" className="form-control" required
                    value={form.password}
                    onChange={e => setForm({ ...form, password: e.target.value })} />
                </div>
                <button className="btn btn-primary w-100" disabled={busy}>
                  {busy ? 'Logging in...' : 'Login'}
                </button>
              </form>

              <div className="mt-3 text-center">
                <span>Don’t have an account? </span>
                <Link to="/signup">Sign up</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
